import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { UiTranslationService } from '@core/services/ui-translation.service';
import { TrainAsset, TrainFlashcard } from '../../../deck-train.models';

@Component({
  selector: 'app-audio-conversation-train-front',
  templateUrl: './audio-conversation-train-front.html',
  styleUrl: './audio-conversation-train-front.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AudioConversationTrainFront {
  private readonly deckTranslations =
    inject(UiTranslationService).namespace('deck');

  readonly card = input.required<TrainFlashcard>();
  readonly imageAsset = input<TrainAsset | null>(null);
  readonly audioAsset = input<TrainAsset | null>(null);
  readonly canSpeakQuestion = input(false);
  readonly isAudioPlaying = input(false);
  readonly isQuestionAudioPlaying = input(false);
  readonly speak = output<void>();
  readonly playAudio = output<void>();

  readonly t = this.deckTranslations.t;

  get imageAlt(): string {
    return this.imageAsset()?.fileName || this.t()['train.frontImage'];
  }

  get hasAudio(): boolean {
    return Boolean(this.audioAsset()?.url);
  }
}
